// console.log('product-personalization.js');
let perButtons = {
  btn_personalization: '.js-personalization-button',
  btn_location: '.js-location-btn',
  btn_type:'.js-type-button',
  btn_typeMonogram:".js-btn-type-monogram",
  btn_typeName:".js-btn-type-name",
  btn_typePatch:".js-btn-type-patch",
  btn_next:'.js-btn-next',
  btn_font:'.js-font-button',
  btn_color:'.js-color-button',
  btn_patch:'.js-patch-button',
  btn_symbol:'.js-btn-symbol',
  btn_bundle_product: '.js-bundle-product-btn',
  btn_bundle_location: '.js-bundle-product-location-btn',
  btn_AddMore: '.js-btn-add-more-design',
  btn_AddMore_confirmPer: '.js-confirmation-add-more',
  btn_per_AddToCart:'.js-personalization-add-to-cart-btn',
  btn_cus_Confirmation: '.js-btn-customization-confirmation',
  btn_back:'.js-btn-back',
  btn_accordionToggle:'.js-accordion-toggle-btn',
  btn_confirmPersonalization:'.js-btn-confirm-personalization',
}

let perWrappers = {
  wrp_accordion_type:'.accordion--wrapper[data-type="type"]',
  wrp_accordion_details:'.accordion--wrapper[data-type="details"]',
  wrp_details_fonts: '.js-fonts-wrapper',
  wrp_details_colors: ".js-colors--wrapper",
  wrp_details_patches: ".js-patches--wrapper",
  wrp_details_symbols:'.js-symbols--wrapper',
  wrp_details_nameText: '.js-name-text-field--wrapper',
  wrp_details_MonogramText: '.js-monogram-text-field--wrapper',
  wrp_cus_BlockWrapper: '.js-customization-block-wrapper',
  wrp_cus_InfoWrapper: '.customization-info--wrapper',
  wrp_accordion:'.accordion--wrapper',
  wrp_per_Cart: '.js-personalization-cart--wrapper',
  wrp_per_Image:'.js-personalization-image--wrapper',
  wrp_locationConfirmationBox:'.js-location-confirmation-box--wrapper',
  wrp_personalizationContent:'.js-personalization-content',
  wrp_main_product:'.shopify-section--single-product'
}

let cartSelectors = {
  btn_cart_qty:'.js-per-qty-button',
  wrp_cart_item: '.cart__item'
}

let _$ = {
  quickView:'.quick-view__container',
  popupOverlay:'.personalization-popup__overlay',
  eleSelectedPreview:'.js-selected-data',
  personalizationPreview:'.js-personalization-preview',
  textInput:'.js-text-input',
  variantSelect:'[name="id"].variant-select',
  monogram_textLimitation:'.js-text-limitation-momogram',
  name_textLimitation:'.js-text-limitation-name',
  text_count:'.js-text-count',
  svg_icon: '.js-icon-svg',
  ...perButtons,
  ...perWrappers,
  ...cartSelectors
}
let _ = {
  active: 'active',
  completed: 'completed',
  personalizationActivated:'personalization--activated',
  disabled:'disabled',
  error:'error',
  hide:'hide',
  defaultPreview:'default-preview',
  required:'required',
  visibilityHidden: 'visibility-hidden',
  previewLocked:'preview-locked',
  confirmationScreenActive:'confirmation-screen-active'
}

let sessionItem = {
  cartPersonalizeItem:'theme:cart-personalize-item',
  cartPersonalizeItemEdit:'theme:cart-personalize-item-edit'
}

let itemPropertyKeys = {
  product:"Product",
  location:"Location",
  type:"Type",
  characters:"Characters",
  icon:"Icon",
  font:"Font",
  color:"Color",
  patch:"Patch"
}

let type = {};
class productPersonalization extends HTMLElement{
  connectedCallback() {
    this.userCustomizations = {};
    this.currentLocation = null;
    this.personalizationJson = JSON.parse(this.querySelector('[type="application/json"]').innerText);
    this.personalizationImageWrapper = this.querySelector(_$.wrp_per_Image);
    this.accordion_type = this.querySelector(_$.wrp_accordion_type);
    this.accordion_details = this.querySelector(_$.wrp_accordion_details);
    this.mainSectionWrapper = this.closest(_$.wrp_main_product) || this.closest(_$.quickView);
    this.isBundleProduct = this.personalizationJson.isBundleProduct;

    this.setTypeVariable();

    if (this.closest(_$.quickView)) {
      type.monogram = this.querySelector(_$.btn_typeMonogram).dataset.type;
      type.name = this.querySelector(_$.btn_typeName).dataset.type;
      type.patch = this.querySelector(_$.btn_typePatch).dataset.type;
      window.accordionListeners();
    }
    
    this.personalizationJson.product.variants = this.personalizationJson.product.variants.map(variant => {
      variant.metadata = this.personalizationJson.variantMetaData[variant.id];
      return variant;
    });
    // console.log(this.personalizationJson);

    this.querySelector('[modal-close]').addEventListener('click',this.close.bind(this));
    this.querySelector(_$.popupOverlay).addEventListener('click',this.close.bind(this));
    this.querySelectorAll(_$.btn_symbol).forEach(button => this._handleSymbolButton(button));
    this.querySelectorAll(_$.btn_color).forEach(button => this._handleColorButton(button));
    this.querySelectorAll(_$.btn_font).forEach(button => this._handleFontButton(button));
    this.querySelectorAll(_$.btn_location).forEach(button => this._LocationButtonListener(button));
    this.querySelectorAll(_$.btn_type).forEach(button => this._TypeButtonListener(button));
    this.querySelectorAll(_$.btn_next).forEach(button => this._NextButtonListener(button));
    this.querySelectorAll(_$.btn_patch).forEach(button => this._PatchButtonListener(button));
    this.querySelector(_$.btn_AddMore).addEventListener('click',this._addMoreDesign.bind(this));
    this.querySelector(_$.btn_AddMore_confirmPer).addEventListener('click',this._addMoreDesignConfirmPer.bind(this));
    this.querySelector(_$.btn_cus_Confirmation).addEventListener('click',this._cusConfirmation.bind(this));
    this.querySelector(_$.btn_confirmPersonalization).addEventListener('click',this._cusConfirmation.bind(this));
    this.querySelector(_$.btn_per_AddToCart).addEventListener('click',this._personalizationAddToCart.bind(this));
    this.querySelector(_$.btn_back).addEventListener('click',this._backButtonListener.bind(this));


    this.querySelectorAll(_$.btn_bundle_product).forEach(button => this._BundleProductButtonListener(button));
    this.querySelectorAll(_$.btn_bundle_location).forEach(button => this._BundleLocationButtonListener(button));

    // window.addEventListener('resize',this._setFontSize.bind(this))

    this.querySelectorAll(_$.textInput).forEach(input => this._InputTextListener(input));

    this.addEventListener('accordion:open',this._openAccordion.bind(this));
    this.addEventListener('accordion:close',this._closeAccordion.bind(this));

    // this.addEventListener("personalization:change",this.handlePersonalizationPreview.bind(this))
    this.addEventListener("personalization:variantChange",this._handleVariantChange.bind(this))

    // this.patches = this.querySelector('[data-type="patches"]'); 
  }

  setTypeVariable(){
    let monogramBtn = this.querySelector(_$.btn_typeMonogram);
    let nameBtn = this.querySelector(_$.btn_typeName);
    let patchBtn = this.querySelector(_$.btn_typePatch);

    type.monogram = monogramBtn ? monogramBtn.dataset.type : null;
    type.name = nameBtn ? nameBtn.dataset.type : null;
    type.patch = patchBtn ? patchBtn.dataset.type : null;
  }

  /**
   * Get Functions
   */

  get selectedVariant(){
    let currentVariantID = this.mainSectionWrapper.querySelector(_$.variantSelect).selectedOptions[0].value;
    let variantJson = this.personalizationJson.product.variants.find(variant => variant.id == parseInt(currentVariantID));
    return variantJson;
  }

  get isSelectedLocationCompleted(){
    let locationCompleted = false;
    let currentLocation = this.userCustomizations[this.currentLocation];

    if(currentLocation == undefined) return false;
    if(currentLocation.type == undefined || currentLocation.type == "") return false;

    switch (currentLocation.type) {
      case type.monogram:
        if(currentLocation.details.monogramText != "") locationCompleted = true;
        break;
      case type.name:
        if(currentLocation.details.nameText != "") locationCompleted = true;
        break;
      case type.patch:
        if(currentLocation.details.patches.name != "") locationCompleted = true;
        break;
    }

    return locationCompleted;
  }

  get personalizationPreviewHTML(){
    return this.personalizationJson.dynamicElementHTml.personalizationPreview;
  }

  get patchImageHTML(){
    return this.personalizationJson.dynamicElementHTml.patchImage;
  }

  get isAllLocationsCompleted(){
    let allLocationCompleted = true
    let btnSelector = (this.isBundleProduct) ? _$.btn_bundle_location : _$.btn_location;
    this.querySelectorAll(`${btnSelector}:not(.${_.hide})`).forEach(button => {
      if(!button.classList.contains(_.completed)) allLocationCompleted = false;
    });
    return allLocationCompleted;
  }

  get isDetailsCompleted(){
    let currentLocation = this.userCustomizations[this.currentLocation];
    let isCompleted = false;
    switch (currentLocation.type) {
      case type.monogram:
        if(currentLocation.details.monogramText != "" || currentLocation.details.icon != "") isCompleted = true;
        break;
      case type.name:
        if(currentLocation.details.nameText != "" || currentLocation.details.icon != "") isCompleted = true;
        break;
      case type.patch:
        if(currentLocation.details.patches.name != "") isCompleted = true;
        break;
    }
    return isCompleted;
  }

  getConfirmationBoxInfoHTML(actionButton = true){
    let dynamicElementHTml = this.personalizationJson.dynamicElementHTml;
    let actionButtons = actionButton ? `${dynamicElementHTml.editPersonalizationButton}${dynamicElementHTml.deletePersonalizationButton}` : ``;
    return dynamicElementHTml.confirmationBoxInfo.replace('{{actionButtons}}',actionButtons);
  }

  get sessionCartItem(){
    let cartPersonalizeItem = window.sessionStorage.getItem(sessionItem.cartPersonalizeItem);
    if(cartPersonalizeItem == null){
      return null;
    }
    let splitItem = cartPersonalizeItem.split('|');
    return {
      key:splitItem[0],
      quantity: splitItem[1]
    }
  }

  /**
   * Global Functions
   */

  
  setupPersonalization(){
    let cartPersonalizeItemEdit = JSON.parse(window.sessionStorage.getItem(sessionItem.cartPersonalizeItemEdit));
    let perItemsJsonEdit = cartPersonalizeItemEdit.perItemsJsonEdit;
    let properties = Object.keys(perItemsJsonEdit.properties).map((element) => perItemsJsonEdit.properties[element]).map(element => {
        let object = {}
        element.split('|').forEach(ele => {
            let splt = ele.split(":");
            object[splt[0].trim()] = splt[1].trim()
        });
        return object
    });
    // console.log(properties);
    properties.forEach(location => {

      let btn_location = this.querySelector(`${_$.btn_location}[data-position-name="${location[itemPropertyKeys.location]}"]`);
      let btn_product = null;
      if(this.isBundleProduct){
        btn_product = this.querySelector(`${_$.btn_bundle_product}[data-name="${location[itemPropertyKeys.product]}"]`);
        btn_location = this.querySelector(`${_$.btn_bundle_location}[data-name="${location[itemPropertyKeys.location]}"]`);
      }
      let btn_type = this.querySelector(`${_$.btn_type}[data-type="${location[itemPropertyKeys.type]}"]`);
      let btn_patch = this.querySelector(`${_$.btn_patch}[data-patch-name="${location[itemPropertyKeys.patch]}"]`);
      let btn_icon = this.querySelector(`${_$.btn_symbol}[data-title="${location[itemPropertyKeys.icon]}"]`);
      let inp_monogram = this.querySelector(`${_$.textInput}[data-type="${type.monogram}"]`);
      let inp_text = this.querySelector(`${_$.textInput}[data-type="${type.name}"]`);
      let btn_font = this.querySelector(`${_$.btn_font}[data-cms-font-name="${location[itemPropertyKeys.font]}"]`);

      if(btn_product){
        btn_product.click();
      }

      btn_location.click();
      btn_type.click();
      
      switch (location[itemPropertyKeys.type]) {
        case type.monogram:
          inp_monogram.value = location[itemPropertyKeys.characters];
          inp_monogram.dispatchEvent(new Event('input'));
          break;
        case type.name:
          inp_text.value = location[itemPropertyKeys.characters];
          inp_text.dispatchEvent(new Event('input'));
          break;
        case type.patch:
          btn_patch.click();
          break;
      }

      if(location[itemPropertyKeys.icon]){
        btn_icon.click();
      }

      if(btn_font) btn_font.click();
      if(location[itemPropertyKeys.color]){
        let colorSplit = location[itemPropertyKeys.color].split(" - ");
        let btn_color = this.querySelector(`${_$.btn_color}[data-thread-code="${colorSplit[1].trim()}"]`);
        if(btn_color) btn_color.click();
      }

      this.accordion_details.querySelector(_$.btn_next).click();
    });
    let firstProperty = properties[0];
    if(this.isBundleProduct){
      this.querySelector(`${_$.btn_bundle_product}[data-name="${firstProperty[itemPropertyKeys.product]}"]`).click();
      this.querySelector(`${_$.btn_bundle_location}[data-name="${firstProperty[itemPropertyKeys.location]}"]`).click();
    }else{
      this.querySelector(`${_$.btn_location}[data-position-name="${firstProperty[itemPropertyKeys.location]}"]`).click();
    }
    setTimeout(() => {
      this.accordion_type.querySelector(_$.btn_accordionToggle).click();
    }, 500);

    let completedLocation = Object.keys(this.userCustomizations).filter(key => this.userCustomizations[key].completed == true);
    this.querySelector(_$.btn_confirmPersonalization).classList.toggle(_.hide,completedLocation.length == 0);
  }
  
  setupTextLimitation(){
    let currentLocation = this.personalizationJson.locations[this.currentLocation];
    this.querySelector(`${_$.textInput}[data-type="${type.monogram}"]`).max = currentLocation.text_limitations.monogram;
    this.querySelector(`${_$.textInput}[data-type="${type.monogram}"]`).dataset.max = currentLocation.text_limitations.monogram;
    this.querySelectorAll(_$.monogram_textLimitation).forEach(element => element.innerHTML = currentLocation.text_limitations.monogram);

    let activeType = this.querySelector(`${_$.btn_type}.${_.active}`);
    if(!activeType) return;
    if(activeType.dataset.type == type.name){
      let selectedFont = this.querySelector(`${_$.btn_font}.${_.active}`);
      let selectedSymbol = this.querySelector(`${_$.btn_symbol}.${_.active}`);
      let fontLimitation = (parseInt(selectedFont.dataset.cmsFontLimitation) != 0) ? selectedFont.dataset.cmsFontLimitation : currentLocation.text_limitations.name;
      let substring = fontLimitation;
      if(selectedSymbol) substring--;
      let input = this.querySelector(`${_$.textInput}[data-type="${type.name}"]`);
      input.value = input.value.substring(0,substring);
      input.max = fontLimitation;
      input.dataset.max = fontLimitation;
      this.querySelectorAll(_$.name_textLimitation).forEach(element => element.innerHTML = fontLimitation);
    }
  }

  initializeSelectedLocation(){
    let currentLocation = this.userCustomizations[this.currentLocation];
    if(currentLocation.type == undefined || currentLocation.type == ""){
      this.resetLocationCustomization();
      return;
    }

    let typeSection = this.accordion_type;
    let detailsSection = this.accordion_details;

    typeSection.classList.add(_.completed);
    detailsSection.classList.add(_.completed);
    detailsSection.classList.remove(_.disabled);

    typeSection.querySelector(`${_$.btn_type}[data-type="${currentLocation.type}"]`).click();

    detailsSection.querySelector(`${_$.textInput}[data-type="${type.monogram}"]`).value = currentLocation.details.monogramText;
    detailsSection.querySelector(`${_$.textInput}[data-type="${type.name}"]`).value = currentLocation.details.nameText;

    detailsSection.querySelector(`${_$.btn_font}[data-cms-font-name='${currentLocation.details.fonts}']`).click();
    detailsSection.querySelector(`${_$.btn_color}[data-value="${currentLocation.details.colors}"]`).click();

    if(currentLocation.details.icon != ""){
      detailsSection.querySelector(`${_$.btn_symbol}[data-title="${currentLocation.details.icon}"]`).click();
    }else{
      detailsSection.querySelector(`${_$.btn_symbol}.${_.active}`) ? detailsSection.querySelector(`${_$.btn_symbol}.${_.active}`).click() : null;
    }

    if(currentLocation.type == "Patch"){
      detailsSection.querySelector(`${_$.btn_patch}[data-patch-name="${currentLocation.details.patches.name}"]`).click();
    }

    typeSection.querySelector(_$.btn_next).disabled = false;
    typeSection.querySelector(_$.btn_next).classList.remove(_.disabled);
    detailsSection.querySelector(_$.btn_next).disabled = false;
    detailsSection.querySelector(_$.btn_next).classList.remove(_.disabled);

  }

  resetLocationCustomization(){
    // console.log("resetLocationCustomization")

    let typeSection = this.accordion_type;
    let detailsSection = this.accordion_details;
    
    typeSection.classList.remove(_.completed);
    detailsSection.classList.remove(_.completed);
    detailsSection.classList.add(_.disabled);

    if(typeSection.querySelector(`${_$.btn_type}.${_.active}`)) typeSection.querySelector(`${_$.btn_type}.${_.active}`).classList.remove(_.active);
    if(detailsSection.querySelector(`${_$.btn_patch}.${_.active}`)) detailsSection.querySelector(`${_$.btn_patch}.${_.active}`).classList.remove(_.active);

    this.querySelectorAll(_$.btn_next).forEach(button => {
      button.classList.add(_.disabled);
      button.disabled = true;
    });

    detailsSection.querySelectorAll(_$.textInput).forEach(input => {
      input.value = "";
      input.max = input.dataset.max;
    });
    this.querySelectorAll(_$.text_count).forEach(element => element.innerHTML = '0');

    if(detailsSection.querySelector(`${_$.btn_symbol}.${_.active}`)) detailsSection.querySelector(`${_$.btn_symbol}.${_.active}`).classList.remove(_.active);

  }

  updateSelectionPreview(){
    let currentLocation = this.userCustomizations[this.currentLocation];

    //Type Accordion
    {
      let wrapper = this.accordion_type;
      wrapper.querySelector(_$.eleSelectedPreview).innerHTML = `${currentLocation.type}`;
    }

    //Details Accordion
    {
      let wrapper = this.accordion_details;
      let previewSelectionContent = "";
      let iconText = currentLocation.details.icon != "" ? `${currentLocation.details.icon}&nbsp;` : "";
      switch (currentLocation.type) {
        case type.monogram:
          let monogramText = currentLocation.details.monogramText != "" ? `"${currentLocation.details.monogramText}"&nbsp;` : "";
          previewSelectionContent = `${monogramText}${iconText}<span>${currentLocation.details.fonts}</span>&nbsp;${currentLocation.details.colors}`;
          break;
        case type.name:
          let nameText = currentLocation.details.nameText != "" ? `"${currentLocation.details.nameText}"&nbsp;` : "";
          previewSelectionContent = `${nameText}${iconText}<span>${currentLocation.details.fonts}</span>&nbsp;${currentLocation.details.colors}`;
          break;
        case type.patch:
          if(currentLocation.details.patches) previewSelectionContent = `${currentLocation.details.patches.name}`;
          break;
      }
      wrapper.querySelector(_$.eleSelectedPreview).innerHTML = previewSelectionContent;
    }
    // this._closeAccordion();
  }
  
  updateUserSelection(){
    // console.log("updateUserSelection :: ")
    let activeLocationJson = this.personalizationJson.locations[this.currentLocation];
    this.userCustomizations[this.currentLocation] = {};
    if (this.isBundleProduct) {
      this.userCustomizations[this.currentLocation].bundle_product = this.querySelector(`${_$.btn_bundle_product}.${_.active}`).dataset.name;
    }
    this.userCustomizations[this.currentLocation].name = activeLocationJson.location_name;
    let typeButton = this.querySelector(`${_$.btn_type}.${_.active}`);
    let detailsSection = this.accordion_details;


    let details_nameText = detailsSection.querySelector(_$.wrp_details_nameText);
    let details_MonogramText = detailsSection.querySelector(_$.wrp_details_MonogramText);
    let details_fonts = detailsSection.querySelector(_$.wrp_details_fonts);
    let details_colors = detailsSection.querySelector(_$.wrp_details_colors);
    let details_patches = detailsSection.querySelector(_$.wrp_details_patches);
    let details_symbols = detailsSection.querySelector(_$.wrp_details_symbols);


    let selectedColor = detailsSection.querySelector(`${_$.btn_color}.${_.active}`);
    let selectedPatch = detailsSection.querySelector(`${_$.btn_patch}.${_.active}`);
    let MonogramTextInput = details_MonogramText.querySelector('[type="text"]');
    let nameTextInput = details_nameText.querySelector('[type="text"]');
    let selectedFont = detailsSection.querySelector(`${_$.btn_font}.${_.active}`);
    let selectedSymbol = detailsSection.querySelector(`${_$.btn_symbol}.${_.active}`);

    let inp_Monogram = this.querySelector(`${_$.textInput}[data-type="${type.monogram}"]`);
    let inp_Text = this.querySelector(`${_$.textInput}[data-type="${type.name}"]`);
    let inp_Monogram_max = parseInt(inp_Monogram.dataset.max);
    let inp_Text_max = parseInt(inp_Text.dataset.max);
    let inp_Monogram_count_ele = inp_Monogram.nextElementSibling.querySelector(_$.text_count);
    let inp_Text_count_ele = inp_Text.nextElementSibling.querySelector(_$.text_count);
    let inp_Monogram_count = parseInt(inp_Monogram.value.length);
    let inp_Text_count = parseInt(inp_Text.value.length);

    let detailsObject = {
      monogramText: MonogramTextInput.value,
      nameText: nameTextInput.value,
      fonts: selectedFont.dataset.cmsFontName,
      fontFamily:selectedFont.dataset.fontFamily,
      colors: selectedColor.dataset.value,
      threadCode: selectedColor.dataset.threadCode,
      icon: (selectedSymbol) ? selectedSymbol.dataset.title : "",
      iconSVG: (selectedSymbol) ? selectedSymbol.querySelector(_$.svg_icon) : "",
      patches: {
        name: (selectedPatch) ? selectedPatch.dataset.patchName : "",
        id: (selectedPatch) ? selectedPatch.dataset.patchId : "",
        price: (selectedPatch) ? selectedPatch.dataset.patchPrice : "",
        image: (selectedPatch) ? selectedPatch.dataset.patchImage : ""
      }
    }

    this.userCustomizations[this.currentLocation].details = detailsObject;

    details_MonogramText.classList.add(_.hide);
    details_nameText.classList.add(_.hide);
    details_fonts.classList.add(_.hide);
    details_colors.classList.add(_.hide);
    details_patches.classList.add(_.hide);
    details_symbols.classList.add(_.hide);

    let previewButton = this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]:not(.${_.defaultPreview})`);
    let currentLocation = this.userCustomizations[this.currentLocation];
    if(typeButton){
      if(previewButton && typeButton.dataset.type != type.patch){
        if(!previewButton.querySelector('span')){
          previewButton.insertAdjacentHTML('afterbegin',`<span></span>`);
        }
        this._applyFontHandleToPreview(previewButton);
      }
      this.userCustomizations[this.currentLocation].type = typeButton.dataset.type;
      detailsSection.classList.remove(_.disabled);
      switch (typeButton.dataset.type) {
        case type.monogram:
          details_MonogramText.classList.remove(_.hide);
          details_fonts.classList.remove(_.hide);
          details_colors.classList.remove(_.hide);
          if (activeLocationJson.hide_in_line_icons == false) {
            details_symbols.classList.remove(_.hide);
          }
          if(previewButton){
            previewButton.querySelector('span').innerHTML = currentLocation.details.monogramText;
            // previewButton.classList.toggle(_.active,currentLocation.details.monogramText != "");
          }

          if(selectedSymbol){
            inp_Monogram.max = (inp_Monogram_max - 1);
            inp_Monogram_count_ele.innerHTML = (inp_Monogram_count == 0) ? 1 : inp_Monogram_count + 1;
          }else{
            inp_Monogram.max = inp_Monogram_max;
            inp_Monogram_count_ele.innerHTML = inp_Monogram_count;
            this.querySelectorAll(_$.btn_symbol).forEach(button => {
              button.classList.toggle(_.disabled,(inp_Monogram_count == inp_Monogram_max));
              button.disabled = (inp_Monogram_count == inp_Monogram_max);
            });
          }
          
          break;
        case type.name:
          details_nameText.classList.remove(_.hide);
          details_fonts.classList.remove(_.hide);
          details_colors.classList.remove(_.hide);
          if (activeLocationJson.hide_in_line_icons == false) {
            details_symbols.classList.remove(_.hide);
          }
          if(previewButton){
            previewButton.querySelector('span').innerHTML = currentLocation.details.nameText;
            // previewButton.classList.toggle(_.active,currentLocation.details.nameText != "");
          }

          if(selectedSymbol){
            inp_Text.max = (inp_Text_max - 1);
            inp_Text_count_ele.innerHTML = (inp_Text_count == 0) ? 1 : inp_Text_count + 1;
          }else{
            inp_Text.max = inp_Text_max;
            inp_Text_count_ele.innerHTML = inp_Text_count;
            this.querySelectorAll(_$.btn_symbol).forEach(button => {
              button.classList.toggle(_.disabled,(inp_Text_count == inp_Text_max));
              button.disabled = (inp_Text_count == inp_Text_max);
            });
          }

          break;
        case type.patch:
          details_patches.classList.remove(_.hide);
          // console.log(currentLocation.details.patches)
          if(previewButton && currentLocation.details.patches.name != ""){
            if(previewButton.querySelector('img')){
              previewButton.querySelector('img').outerHTML = this.patchImageHTML.replace('{{imageSrc}}',currentLocation.details.patches.image).replace('{{imageAlt}}',currentLocation.details.patches.name);
            }else{
              previewButton.insertAdjacentHTML('afterbegin',this.patchImageHTML.replace('{{imageSrc}}',currentLocation.details.patches.image).replace('{{imageAlt}}',currentLocation.details.patches.name));
            }
            previewButton.classList.add(_.active);
          }
          break;
      }
    }

    let symPrevBtn = previewButton || this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]`);
    if(symPrevBtn){
      let symbolImage = symPrevBtn.querySelector('.inline-icon-image--wrapper');
      if(selectedSymbol){
        let imageHtml = `<div class="inline-icon-image--wrapper">${selectedSymbol.querySelector(_$.svg_icon).outerHTML}</div>`
        if(symbolImage){
          symbolImage.outerHTML = imageHtml;
        }else{
          symPrevBtn.insertAdjacentHTML('beforeend',imageHtml);
        }
      }else{
        if(symbolImage){
          symbolImage.remove();
        }
      }
    }

    // this.querySelectorAll(`${_$.personalizationPreview}:not([data-location-id="${this.currentLocation}"])`).forEach(element => {
    //   if(!element.classList.contains(_.active)){
    //     element.remove();
    //   }
    // });
    

    if(this.personalizationJson.isBundleProduct == true){
      this.userCustomizations[this.currentLocation].completed = this.querySelector(`${_$.btn_bundle_location}[data-name="${currentLocation.name}"]`).classList.contains(_.completed);
    }else{
      this.userCustomizations[this.currentLocation].completed = this.querySelector(`${_$.btn_location}[data-location-id="${this.currentLocation}"]`).classList.contains(_.completed);
    }

    if(Object.keys(this.personalizationJson.locations).length > 1){
      if(this.isBundleProduct == false){ 
        this.querySelector(_$.btn_AddMore).classList.toggle(_.hide,this.isAllLocationsCompleted);
      }
    }else{
      this.querySelector(_$.btn_AddMore).classList.add(_.hide);
    }

    detailsSection.style.setProperty('--personalization-font',selectedFont.dataset.fontFamily)

    // let completedLocation = Object.keys(this.userCustomizations).filter(key => this.userCustomizations[key].completed == true);
    // this.querySelector(_$.btn_confirmPersonalization).classList.toggle(_.hide,completedLocation.length == 0);

    // console.log(this.userCustomizations)
    this.updateSelectionPreview();
    // this._setFontSize();
  }

  updateLocationImage() {
    this.personalizationImageWrapper.classList.add('img-loading');

    const imageElement = this.personalizationImageWrapper.querySelector('img');
    const currentImageId = imageElement.dataset.imageId;
    const variantJson = this.selectedVariant;
    const selectedLocationImage = variantJson.metadata.variant_location_images[this.currentLocation];

    const nextHtml = selectedLocationImage && selectedLocationImage.fileId !== currentImageId
      ? selectedLocationImage.imageHtml
      : variantJson.metadata.featuredImage;

    if (nextHtml) imageElement.outerHTML = nextHtml;

    const newImg = this.personalizationImageWrapper.querySelector('img');
    const clearLoading = () => {
      this.personalizationImageWrapper.classList.remove('img-loading');
      newImg.removeEventListener('load', clearLoading);
      newImg.removeEventListener('error', clearLoading);
    };

    if (newImg.complete) {
      clearLoading();
    } else {
      newImg.addEventListener('load', clearLoading);
      newImg.addEventListener('error', clearLoading);
    }
  }


  displayLocationTypes(){
    let currentLocation = this.personalizationJson.locations[this.currentLocation];
    this.querySelector(`${_$.btn_type}[data-type="${type.monogram}"]`).classList.toggle(_.hide,!(currentLocation.monogram == "true"));
    this.querySelector(`${_$.btn_type}[data-type="${type.name}"]`).classList.toggle(_.hide,!(currentLocation.name == "true"));
    this.querySelector(`${_$.btn_type}[data-type="${type.patch}"]`).classList.toggle(_.hide,!(currentLocation.patch == "true"));
  }

  // Display Current View

  displayCurrentView(view){
    if(this.isBundleProduct){
      this.querySelectorAll(`${_$.personalizationPreview}[data-product='${this.BF_getSelectedProduct}']`).forEach(element => {
        element.classList.toggle(_.hide,!(element.dataset.view === view)); 
      });
    }else{
      this.querySelectorAll(`${_$.personalizationPreview}`).forEach(element => {
        element.classList.toggle(_.hide,!(element.dataset.view === view));
      });
    }
  }

  handlePersonalizationPreview(positionId){
    let positionValue = this.personalizationJson.locations[positionId];

    this.querySelectorAll(`${_$.personalizationPreview}:not(.${_.previewLocked})`).forEach(element => element.remove());

    if(!this.querySelector(`${_$.personalizationPreview}[data-location-id="${positionId}"]`)){
      let style = `
      --x_desktop:${positionValue.desktopX}%;
      --y_desktop:${positionValue.desktopY}%;
      --x_mobile:${positionValue.mobileX}%;
      --y_mobile:${positionValue.mobileY}%;
      --degree:${positionValue.degree}deg;
      --decorations_font_size_desktop:${positionValue.decorations_font_size_desktop}px;
      --decorations_font_size_mobile:${positionValue.decorations_font_size_mobile}px;`;
      let selectedType = this.querySelector(`${_$.btn_type}.${_.active}`) ? this.querySelector(`${_$.btn_type}.${_.active}`).dataset.type.toLowerCase() : "";
      let elementHtml = this.personalizationPreviewHTML.replace('{{styles}}',style).replace('{{locationId}}',positionId).replace('{{view}}',positionValue.view).replace('{{type}}',selectedType);
      this.personalizationImageWrapper.insertAdjacentHTML('beforeend',elementHtml);
      let activeFonts = this.querySelector(`${_$.btn_font}.${_.active}`);
      let activeColor = this.querySelector(`${_$.btn_color}.${_.active}`);
      if(activeFonts) activeFonts.click();
      if(activeColor) activeColor.click();
    }

    this.displayCurrentView(positionValue.view)
  }

  isRestrictedWord(word){
    let restricted_words = this.personalizationJson.restricted_words.split(',');
    return restricted_words.includes(word);
  }

  resetBundle(){

    if(this.isBundleProduct){
      this.BF_resetBundle();
    }

    this.userCustomizations = {};

    this.classList.remove(_.personalizationActivated,_.confirmationScreenActive);

    let customizationBox = this.querySelector(_$.wrp_cus_BlockWrapper);
    let personalizationCart = this.querySelector(_$.wrp_per_Cart);
    customizationBox.classList.remove(_.hide);
    personalizationCart.classList.add(_.hide);
    this.currentLocation = null;

    this.querySelectorAll(_$.btn_location).forEach(button => {
      button.classList.remove(_.active);
      button.classList.remove(_.completed);
      // if(Object.keys(this.userCustomizations).includes(button.dataset.locationId)){
      //   this.userCustomizations[button.dataset.locationId] = {};
      //   this.userCustomizations[button.dataset.locationId].name = button.getAttribute('data-name');
      // }
    })

    let typeSection = this.accordion_type;
    let detailsSection = this.accordion_details;
    
    typeSection.classList.remove(_.completed);
    detailsSection.classList.remove(_.completed);
    detailsSection.classList.add(_.disabled);
    
    this.querySelector(_$.wrp_locationConfirmationBox).classList.add(_.hide);

    if(typeSection.querySelector(`${_$.btn_type}.${_.active}`)) typeSection.querySelector(`${_$.btn_type}.${_.active}`).classList.remove(_.active);

    this.querySelectorAll(_$.btn_next).forEach(button => {
      button.classList.add(_.disabled);
      button.disabled = true;
    });

    (typeSection.querySelector(`${_$.btn_accordionToggle}`).ariaExpanded == 'true') ? typeSection.querySelector(`${_$.btn_accordionToggle}`).click() : null;
    detailsSection.querySelectorAll(_$.textInput).forEach(input => {
      input.value = "";
      input.max = input.dataset.max;
    });
    (detailsSection.querySelector(`${_$.btn_accordionToggle}`).ariaExpanded == 'true') ? detailsSection.querySelector(`${_$.btn_accordionToggle}`).click() : null;

    if(detailsSection.querySelector(`${_$.btn_symbol}.${_.active}`)) detailsSection.querySelector(`${_$.btn_symbol}.${_.active}`).classList.remove(_.active);

    this.querySelectorAll(_$.personalizationPreview).forEach(element => element.remove());
    this.querySelector(_$.btn_back).classList.add(_.visibilityHidden);
    this.querySelector(_$.btn_confirmPersonalization).classList.add(_.hide);
  }

  initializeVariant(){
    if(this.isBundleProduct){
      let productImage = this.BF_getProductImage(true);
      this.personalizationImageWrapper.querySelector('img').outerHTML = productImage.B_product_file_html;
    }else{
      let variantJson = this.selectedVariant;
      this.personalizationImageWrapper.querySelector('img').outerHTML = variantJson.metadata.featuredImage;
    }
    if(window.sessionStorage.getItem(sessionItem.cartPersonalizeItemEdit)){
      this.setupPersonalization();
    }else{
      this.resetBundle();
      setTimeout(() => {
        // Auto-select location if only one location exists
        if (Object.keys(this.personalizationJson.locations).length === 1) {
          const onlyLocationId = Object.keys(this.personalizationJson.locations)[0];
          if (this.isBundleProduct) {
            // Select first product, then location
            const firstProductBtn = this.querySelector(_$.btn_bundle_product);
            if (firstProductBtn) {
              firstProductBtn.click();
              // Find the location for this product
              const onlyLocation = this.personalizationJson.locations[onlyLocationId];
              const locationBtn = this.querySelector(`${_$.btn_bundle_location}[data-name="${onlyLocation.B_location_name}"]`);
              if (locationBtn) {
              setTimeout(() => locationBtn.click(), 50);
              }
            }
          } else {
            const locationBtn = this.querySelector(`${_$.btn_location}[data-location-id="${onlyLocationId}"]`);
            if (locationBtn) {
              locationBtn.click();
            }
          }
        }
      }, 50);
    }
  }

  focusLocationProduct(){
    setTimeout(() => {
      if(this.isBundleProduct){
        this.querySelector(_$.btn_bundle_product).focus();
      }else{
        this.querySelector(_$.btn_location).focus();
      }
    }, 1000);
  }

  open(){
    this.oldFocusedElement = document.activeElement;
    this.classList.add('product-personalization__container--active');
    if(document.querySelector('.personalization-overlay')) document.querySelector('.personalization-overlay').classList.remove("loading-animation");
    document.body.classList.add('overflow--hidden');
    this.initializeVariant();
    this.focusLocationProduct();
  }

  close(){
    this.classList.remove('product-personalization__container--active');
    document.body.classList.remove('overflow--hidden');
    this.resetBundle();
    if(this.oldFocusedElement) this.oldFocusedElement.focus();
  }

  scrollToLocation(){
    setTimeout(() => {
      this.querySelector(_$.wrp_personalizationContent).scrollTo({
        top:0,
        behavior:'smooth'
      });
    }, 100);
  }

  inputAndSymbolValidation(){
    let currentLocation = this.userCustomizations[this.currentLocation]
    let nextBtn = this.accordion_details.querySelector(_$.btn_next);
    let fieldWrapper = this.accordion_details.querySelector('.field:not(.hide)');
    let inputField = fieldWrapper.querySelector(_$.textInput);
    let symbolField = this.accordion_details.querySelector(`${_$.btn_symbol}.${_.active}`);
    let previewLocation = this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]`);
    if(inputField.value.length > 0){
      let tmp = this.isRestrictedWord(inputField.value.toLowerCase()) == true;
      nextBtn.disabled = (tmp || inputField.value == "");
      nextBtn.classList.toggle('disabled',(tmp || inputField.value == ""));
      fieldWrapper.classList.toggle('error',tmp);
    }
    if(symbolField){
      nextBtn.disabled = false;
      nextBtn.classList.remove('disabled');
    }
    previewLocation.classList.add(_.active);
    previewLocation.classList.remove(_.defaultPreview);
    if(inputField.value.length == 0 && !symbolField){
      nextBtn.disabled = true;
      nextBtn.classList.add('disabled');
      previewLocation.classList.add(_.defaultPreview);
      previewLocation.classList.remove(_.active);
      this.showTypeDefaultPreview();

      this.userCustomizations[this.currentLocation].completed = false;
      if(this.isBundleProduct){
        this.querySelector(`${_$.btn_bundle_location}[data-name="${currentLocation.name}"]`).classList.remove(_.completed);

        if(this.BF_completedLocations == 0){
          this.querySelector(`${_$.btn_bundle_product}[data-name="${currentLocation.bundle_product}"]`).classList.remove(_.completed);
        }
      }else{
        this.querySelector(`${_$.btn_location}[data-location-id="${this.currentLocation}"]`).classList.remove(_.completed);
      }
    }

    let completedLocation = Object.keys(this.userCustomizations).filter(key => this.userCustomizations[key].completed == true);
    if(completedLocation.length == 0){
      this.querySelector(_$.wrp_locationConfirmationBox).classList.add(_.hide);
      this.querySelector(_$.btn_confirmPersonalization).classList.add(_.hide);
    }
  }

  // Type Default Preview

  showTypeDefaultPreview(){
    let selectedType = this.querySelector(`${_$.btn_type}.${_.active}`).dataset.type;
    let defaultPreview = this.personalizationJson.TypeDefaultPreview;
    let selectedLocation = this.personalizationJson.locations[this.currentLocation];
    let defaultText = selectedLocation.TypeDefaultText;
    let previewButton = this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]`);
    previewButton.classList.add(_.defaultPreview);
    let span = previewButton.querySelector('span');
    if(previewButton.querySelector('img')){
      previewButton.querySelector('img').remove();
    }
    switch (selectedType) {
      case type.monogram:
        if(span){
          span.innerHTML = defaultText.monogram.toUpperCase();
        }else{
          previewButton.insertAdjacentHTML('afterbegin',`<span>${defaultText.monogram.toUpperCase()}</span>`);
        }
        this._applyFontHandleToPreview(previewButton);
        break;
      case type.name:
        if(span){
          span.innerHTML = defaultText.name;
        }else{
          previewButton.insertAdjacentHTML('afterbegin',`<span>${defaultText.name}</span>`);
        }
        this._applyFontHandleToPreview(previewButton);
        break;
      case type.patch:
        if(this.querySelector(`${_$.btn_patch}.${_.active}`)){
          this.querySelector(`${_$.btn_patch}.${_.active}`).click();
        }else{
          previewButton.innerHTML = this.patchImageHTML.replace('{{imageSrc}}',defaultPreview.patch.image).replace('{{imageAlt}}',defaultPreview.patch.name);
        }
        break;
    }
  }

  /**
   * Event Listeners Functions
   */

  // Location Button
  _LocationButtonListener(button){
    button.addEventListener('click',() => {
      // console.log(button.classList.contains(_.active))
      if(button.classList.contains(_.active)) return;
      let oldLocation = this.currentLocation;
      this.currentLocation = button.dataset.locationId;
      if(this.userCustomizations[oldLocation]){
        if(this.userCustomizations[oldLocation].completed == false){
          delete this.userCustomizations[oldLocation];
        }
      }
      this.updateLocationImage();
      this.displayLocationTypes();
      this.setupTextLimitation();
      this.querySelectorAll(_$.btn_location).forEach(button => {
        button.classList.remove(_.active);
        button.ariaSelected = false;
      });
      button.classList.add(_.active);
      button.ariaSelected = true;
      this.classList.add(_.personalizationActivated);

      this.querySelector(_$.wrp_locationConfirmationBox).classList.add(_.hide);

      if(button.classList.contains(_.completed)){
        this.initializeSelectedLocation();
        this.handlePersonalizationPreview(this.currentLocation);
        // if(this.isAllLocationsCompleted == false) this.querySelector(_$.wrp_locationConfirmationBox).classList.remove(_.hide);
        let typeAccordionBtn = this.accordion_type.querySelector(_$.btn_accordionToggle);
        if(typeAccordionBtn.ariaExpanded == 'false') typeAccordionBtn.click();
        this.querySelector(_$.btn_confirmPersonalization).classList.remove(_.hide);
        return;
      }else{
        this.resetLocationCustomization();
        this.handlePersonalizationPreview(this.currentLocation);
      }
      this.updateUserSelection();
      let typeAccordionBtn = this.accordion_type.querySelector(_$.btn_accordionToggle);
      if(typeAccordionBtn.ariaExpanded == 'false') typeAccordionBtn.click();
      let completedLocation = Object.keys(this.userCustomizations).filter(key => this.userCustomizations[key].completed == true);
      this.querySelector(_$.btn_confirmPersonalization).classList.toggle(_.hide,completedLocation.length == 0);
    });
  }

  // Type Button
  _TypeButtonListener(button){
    button.addEventListener('click',() => {
      if(button.classList.contains(_.active)) return;
      this.querySelectorAll(_$.btn_type).forEach(button => {
        button.classList.remove(_.active);
        button.ariaSelected = false;
      });
      button.classList.add(_.active);
      button.ariaSelected = true;
      let nextBtn = button.closest(_$.wrp_accordion).querySelector(_$.btn_next);
      nextBtn.disabled = false;
      nextBtn.classList.remove(_.disabled);
      let currentLocation = this.userCustomizations[this.currentLocation];

      let isTypeChanged = false;
      if(currentLocation.type != button.dataset.type){
        isTypeChanged = true;
      }

      this.userCustomizations[this.currentLocation].type = button.dataset.type;
      
      this.querySelectorAll(_$.textInput).forEach(input => input.value = '');
      this.querySelectorAll(_$.btn_symbol).forEach(button => {
        button.classList.remove(_.disabled,_.active);
        button.disabled = false;
      });

      this.updateUserSelection();
      this.setupTextLimitation();

      let detailsNextButton = this.accordion_details.querySelector(_$.btn_next);
      let isDisabled = true;
      switch (currentLocation.type) {
        case type.monogram:
          if(currentLocation.details.monogramText != "") isDisabled = false;
          break;
        case type.name:
          if(currentLocation.details.nameText != "") isDisabled = false;
          break;
        case type.patch:
          if(currentLocation.details.patches.name != "") isDisabled = false;
          break;
      }
      detailsNextButton.disabled = (isDisabled == true);
      detailsNextButton.classList.toggle(_.disabled,(isDisabled == true));
      if(this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]`)){
        this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]`).dataset.type = currentLocation.type.toLowerCase();
        if(this.isBundleProduct){
          this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]`).dataset.product = this.BF_getSelectedProduct;
        }
      }
      this.accordion_details.classList.toggle(_.required,(button.dataset.type != type.patch));
      // console.log("---->>>> ",this.currentLocation,currentLocation.completed,currentLocation)
      if(currentLocation.completed ==  false || currentLocation.completed == undefined || isTypeChanged) this.showTypeDefaultPreview();
    });
  }

  // Next Button
  _NextButtonListener(button){
    button.addEventListener('click',() => {
      let mainWrapper = button.closest(_$.wrp_accordion);
      let currentLocation = this.userCustomizations[this.currentLocation]
      mainWrapper.querySelector(_$.btn_accordionToggle).click();
      mainWrapper.classList.add(_.completed);
      if(mainWrapper.nextElementSibling){
        let titleBtn = mainWrapper.nextElementSibling.querySelector(_$.btn_accordionToggle);
        if(titleBtn.ariaExpanded == 'false') titleBtn.click();
      }

      if(mainWrapper.dataset.type == "details"){
        if(this.isBundleProduct){
          this.querySelector(_$.btn_AddMore).classList.toggle(_.hide,(this.BF_getRemainingLocations.length == 0));
          this.querySelector(`${_$.btn_bundle_product}[data-name="${this.BF_getSelectedProduct}"]`).classList.add(_.completed);
          this.querySelector(`${_$.btn_bundle_location}[data-name="${currentLocation.name}"]`).classList.toggle(_.completed,this.isDetailsCompleted);
        }else{
          this.querySelector(`${_$.btn_location}[data-location-id="${this.currentLocation}"]`).classList.toggle(_.completed,this.isDetailsCompleted);
        }
        currentLocation.completed = this.isDetailsCompleted;
        this.querySelector(_$.wrp_locationConfirmationBox).classList.remove(_.hide);
        this.querySelector(_$.btn_confirmPersonalization).classList.add(_.hide);
        this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]`).classList.add(_.previewLocked);
        this.scrollToLocation();
      }

      if(Object.keys(this.personalizationJson.locations).length > 1){
        if(this.isBundleProduct == false){
          this.querySelector(_$.btn_AddMore).classList.toggle(_.hide,this.isAllLocationsCompleted);
        }
      }else{
        this.querySelector(_$.btn_AddMore).classList.add(_.hide);
      }
    });
  }

  // Patch Button
  _PatchButtonListener(button){
    button.addEventListener('click',() => {
      this.querySelectorAll(_$.btn_patch).forEach(button => {
        button.classList.remove(_.active);
        button.ariaSelected = false;
      });
      button.classList.add(_.active);
      button.ariaSelected = true;
      let nextBtn = button.closest(_$.wrp_accordion).querySelector(_$.btn_next);
      nextBtn.disabled = false;
      nextBtn.classList.remove(_.disabled);
      this.updateUserSelection();
      let currentLocation = this.userCustomizations[this.currentLocation];
      let previewButton = this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]`);
      previewButton.innerHTML = this.patchImageHTML.replace('{{imageSrc}}',currentLocation.details.patches.image).replace('{{imageAlt}}',currentLocation.details.patches.name);
    });
  }

  // Helper: stamp the active font's handle as a class on the preview <span>
  _applyFontHandleToPreview(previewEl){
    if(!previewEl) return;
    let span = previewEl.querySelector('span');
    let activeFont = this.querySelector(`${_$.btn_font}.${_.active}`);
    if(span && activeFont && activeFont.dataset.fontHandle){
      [...span.classList].filter(c => c.startsWith('font-handle--')).forEach(c => span.classList.remove(c));
      span.classList.add(`font-handle--${activeFont.dataset.fontHandle}`);
    }
  }

  // Font Button
  _handleFontButton(button){
    button.addEventListener('click',() => {
      this.querySelector('.js-font-button.active').ariaSelected = false;
      this.querySelector('.js-font-button.active').classList.remove('active');
      button.classList.add('active');
      button.ariaSelected = true;
      let previewEl = this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]`);
      if(previewEl){
        previewEl.style.setProperty('--personalization-font',button.dataset.fontFamily);
        let previewSpan = previewEl.querySelector('span');
        if(previewSpan && button.dataset.fontHandle){
          [...previewSpan.classList].filter(c => c.startsWith('font-handle--')).forEach(c => previewSpan.classList.remove(c));
          previewSpan.classList.add(`font-handle--${button.dataset.fontHandle}`);
        }
      }
      this.updateUserSelection();
      this.setupTextLimitation();
    });
  }

  // Color Button
  _handleColorButton(button){
    button.addEventListener('click',() => {
      this.querySelector('.js-color-button.active').ariaSelected = false;
      this.querySelector('.js-color-button.active').classList.remove('active');
      button.classList.add('active');
      button.ariaSelected = true;
      if(this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]`)){
        this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]`).style.setProperty('--personalization-color',button.dataset.color);
      }
      this.updateUserSelection();
    });
  }

  // Symbol Button
  _handleSymbolButton(button){
    button.addEventListener('click',() => {
      let activeElement = this.querySelector(`${_$.btn_symbol}.${_.active}`);
      if(activeElement){
        if(activeElement != button){
          activeElement.classList.remove('active');
        }
      }
      button.classList.toggle('active');
      this.inputAndSymbolValidation();
      this.updateUserSelection();
    });
  }

  // Back Button
  _backButtonListener(event){
    this.accordion_type.querySelector(_$.btn_accordionToggle).click();
  }

  // Accordion Open
  _openAccordion(event){
    let currentLocation = this.userCustomizations[this.currentLocation];
    // if(!this.isBundleProduct){
    //   this.querySelector(`${_$.btn_location}[data-location-id="${this.currentLocation}"]`).classList.toggle(_.completed,this.isSelectedLocationCompleted);
    // }
    // currentLocation.completed = this.isSelectedLocationCompleted;

    let accordion = event.detail.element.closest(_$.wrp_accordion);    
    this.querySelectorAll(_$.wrp_accordion).forEach(element => {
      let accTitle = element.querySelector(_$.btn_accordionToggle);
      if(element != accordion && accTitle.ariaExpanded == 'true'){
        accTitle.click();
      }
    });

    let detailsSection = this.accordion_details;
    let isDetailsOpen = detailsSection.querySelector(_$.btn_accordionToggle).ariaExpanded == 'true';
    this.querySelector(_$.btn_back).classList.toggle(_.visibilityHidden,!isDetailsOpen);
    this.querySelector(_$.wrp_locationConfirmationBox).classList.toggle(_.hide,isDetailsOpen);

    let typeSection = this.accordion_type;
    let isTypeOpen = typeSection.querySelector(_$.btn_accordionToggle).ariaExpanded == 'true';
    if(isTypeOpen){
      this.querySelector(_$.wrp_locationConfirmationBox).classList.add(_.hide);
    }
  }

  // Accordion Close
  _closeAccordion(){
    let currentLocation = this.userCustomizations[this.currentLocation];
    if(currentLocation){
      //Type Accordion
      {
        let wrapper = this.accordion_type;
        if(currentLocation.type != "" && currentLocation.type != undefined){
          wrapper.classList.add(_.completed);
        }else{
          wrapper.classList.remove(_.completed);
        }
      }

      //Details Accordion
      {
        let wrapper = this.accordion_details;
        let isCompleted = false
        switch (currentLocation.type) {
          case type.monogram:
            if(currentLocation.details.monogramText != "") isCompleted = true;
            break;
          case type.name:
            if(currentLocation.details.nameText != "") isCompleted = true;
            break;
          case type.patch:
            if(currentLocation.details.patches.name != "") isCompleted = true;
            break;
        }
        wrapper.classList.toggle(_.completed,isCompleted);
      }
    }

    let detailsSection = this.accordion_details;
    let isDetailsOpen = detailsSection.querySelector(_$.btn_accordionToggle).ariaExpanded == 'true';
    this.querySelector(_$.btn_back).classList.toggle(_.visibilityHidden,!isDetailsOpen);
  }

  // Add to cart Personalization
  _personalizationAddToCart(event){
    let sessionCartItem = this.sessionCartItem;
    let button = event.currentTarget;
    button.classList.add(_.disabled);
    button.disabled = true;
    let variantJson = this.selectedVariant;
    let locationArray = Object.keys(this.userCustomizations).map(element => this.userCustomizations[element]).filter(element => element.completed == true);
    let InitialsProduct = this.personalizationJson.InitialsProduct;
    let uniqueId = new Date().getTime();
    let items = [];
    let locationProperties = {};
    locationArray.forEach((location,index) => {
      let tmp = [];
      if(this.isBundleProduct) tmp.push(`${itemPropertyKeys.product}: ${location.bundle_product}`);
      tmp.push(`${itemPropertyKeys.location}: ${location.name}`);
      tmp.push(`${itemPropertyKeys.type}: ${location.type}`);
      let price = 0;
      switch (location.type) {
        case type.monogram:
          if(location.details.monogramText != ""){
            tmp.push(`${itemPropertyKeys.characters}: ${location.details.monogramText}`);
          }
          if(location.details.icon != ""){
            tmp.push(`${itemPropertyKeys.icon}: ${location.details.icon}`);
          }
          tmp.push(`${itemPropertyKeys.font}: ${location.details.fonts}`);
          tmp.push(`${itemPropertyKeys.color}: ${location.details.colors} - ${location.details.threadCode}`);
          break;
        case type.name:
          if(location.details.nameText != ""){
            tmp.push(`${itemPropertyKeys.characters}: ${location.details.nameText}`);
          }
          if(location.details.icon != ""){
            tmp.push(`${itemPropertyKeys.icon}: ${location.details.icon}`);
          }
          tmp.push(`${itemPropertyKeys.font}: ${location.details.fonts}`);
          tmp.push(`${itemPropertyKeys.color}: ${location.details.colors} - ${location.details.threadCode}`);
          break;
        case type.patch:
          tmp.push(`${itemPropertyKeys.patch}: ${location.details.patches.name}`);
          break;
      }
      let infoText = tmp.join(' | ');
      locationProperties[`Location_${(index + 1)}`] = infoText;
    });

    if(this.isBundleProduct) locationProperties[`_is_Bundle_Product`] = true;

    let itemQty = 1;
    if(sessionCartItem != null){
      itemQty = sessionCartItem.quantity
    }

    // --- Holiday Gift Logic Start ---
    const holidayGiftGamificationEnabled = window.SDG?.holiday_gift_gamification_enabled;
    let holidayGiftTag = window.holidayGamification?.product_tag;
    let isHolidayGift = false;
    if (holidayGiftGamificationEnabled && (typeof holidayGiftTag === 'string' && holidayGiftTag.trim() === '')) {
      // If the tag is blank, all products are holiday gifts
      isHolidayGift = true;
    } else if (holidayGiftGamificationEnabled && holidayGiftTag && Array.isArray(this.personalizationJson.product.tags)) {
      isHolidayGift = this.personalizationJson.product.tags.includes(holidayGiftTag);
    }
    // --- Holiday Gift Logic End ---

    let mainItemProperties = {
      _personalization_id: uniqueId,
      _bundle_item: 'main',
      "_final-sale": true,
      _LPROP: "Final Sale",
      ...locationProperties
    };

    if (isHolidayGift) {
      mainItemProperties["_holiday_gift"] = true;
    }

    items.push(
      {
        id: variantJson.id,
        quantity: itemQty,
        properties: mainItemProperties
      }
    );

    locationArray.forEach(location => {
      if(location.type == "Patch"){
        items.push(
          {
            id:location.details.patches.id,
            quantity:itemQty,
            properties:{
              _personalization_id:uniqueId,
              _bundle_item:'related_multiple',
              location: location.name,
              ...(isHolidayGift ? { "_holiday_gift": true } : {})
            }
          }
        );
      }else{
        let initials = location.details.monogramText;
        if(location.type == type.name){
          initials = location.details.nameText;
        }
        items.push(
          {
            id:InitialsProduct.variants[0].id,
            quantity:itemQty,
            properties:{
              _personalization_id:uniqueId,
              _bundle_item:'related_multiple',
              location: location.name,
              Initials: initials,
              Color:location.details.colors,
              Font:location.details.fonts,
              ...(isHolidayGift ? { "_holiday_gift": true } : {})
            }
          }
        );
      }
    });

    items = items.reverse();
    
    if(window.sessionStorage.getItem(sessionItem.cartPersonalizeItemEdit)){
      let cartPersonalizeItemEdit = JSON.parse(window.sessionStorage.getItem(sessionItem.cartPersonalizeItemEdit));
      let perItemsJson = cartPersonalizeItemEdit.perItemsJson;
      let perItemsJsonEdit = cartPersonalizeItemEdit.perItemsJsonEdit;
      let updates = {};
      updates[perItemsJsonEdit.key] = 0;
      Object.keys(perItemsJson).forEach(key => {
        updates[key] = 0;
      });
      calpak.updateCartItems(updates,(data) => {
        // calpak.updateCart(data);
        // console.log("cart Item Removed")
        calpak.addToCart(items,null,(data) => {
          calpak.updateCart(data);
          button.classList.remove(_.disabled);
          button.disabled = false;
          this.close();
          window.calpak.openCart();
          window.sessionStorage.removeItem(sessionItem.cartPersonalizeItemEdit);
         });  
      });
      return;
    }

    if(sessionCartItem != null){
      let updates = {};
      updates[sessionCartItem.key] = 0;
      calpak.updateCartItems(updates,(data) => {
        // calpak.updateCart(data);
        // console.log("cart Item Removed")
        calpak.addToCart(items,null,(data) => {
          calpak.updateCart(data);
          button.classList.remove(_.disabled);
          button.disabled = false;
          this.close();
          window.calpak.openCart();
          window.sessionStorage.removeItem(sessionItem.cartPersonalizeItem);
         });  
      });
    }else{
      calpak.addToCart(items,null,(data) => {
       calpak.updateCart(data);
       button.classList.remove(_.disabled);
       button.disabled = false;
       this.close();
       window.calpak.openCart();
      });
    }

  }

  // Add More Design Button
  _addMoreDesign(){
    this.scrollToLocation();
    this.resetLocationCustomization();
    let btnSelector = (this.isBundleProduct) ? _$.btn_bundle_location : _$.btn_location;
    if(this.isBundleProduct){
      if(this.isAllLocationsCompleted){
        let productBtn = this.querySelector(`${_$.btn_bundle_product}:not(.${_.completed})`);
        if(productBtn){
          productBtn.click();
        }else{
          let remainingLocations = this.BF_getRemainingLocations;
          if(remainingLocations.length > 0){
            let location = remainingLocations.array[0];
            this.querySelector(`${_$.btn_bundle_product}[data-name="${location.B_product_name}"]`).click();
            setTimeout(() => {
              this.querySelector(`${_$.btn_bundle_location}[data-name="${location.B_location_name}"]`).click();
            }, 50);
          }
        }
        this.classList.remove(_.personalizationActivated);
      }else{
        this.querySelector(`${btnSelector}:not(.${_.completed})`).click();
        this.querySelector(_$.wrp_locationConfirmationBox).classList.add(_.hide);
        this.querySelector(_$.btn_confirmPersonalization).classList.remove(_.hide);
      }
      return;
    }
    this.querySelector(`${btnSelector}:not(.${_.completed})`).click();
    this.querySelector(_$.wrp_locationConfirmationBox).classList.add(_.hide);
    this.querySelector(_$.btn_confirmPersonalization).classList.remove(_.hide);
  }

  // Add More Design - Confirmation page.
  _addMoreDesignConfirmPer(){
    this.scrollToLocation();
    this.classList.remove(_.confirmationScreenActive);
    this.querySelector(_$.wrp_per_Cart).classList.add(_.hide);
    this.querySelector(_$.wrp_cus_BlockWrapper).classList.remove(_.hide);

    if (this.isBundleProduct) {
      let remainingLocations = this.BF_getRemainingLocations;
      if(remainingLocations.length > 0){
        let location = remainingLocations.array[0];
        this.querySelector(`${_$.btn_bundle_product}[data-name="${location.B_product_name}"]`).click();
        setTimeout(() => {
          this.querySelector(`${_$.btn_bundle_location}[data-name="${location.B_location_name}"]`).click();
        }, 50);
      }
      return;
    }
    this.querySelector(`${_$.btn_location}.${_.active}`).classList.remove(_.active);
    if(this.querySelector(`${_$.btn_location}:not(.${_.completed})`)){
      this.querySelector(`${_$.btn_location}:not(.${_.completed})`).click();
    }else{
      this.querySelector(`${_$.btn_location}`).click();
    }
  }

  // Confirm Personalization Button
  _cusConfirmation(){
    this.classList.add(_.confirmationScreenActive);
    this.scrollToLocation();
    this.resetLocationCustomization();
    this.querySelector(_$.wrp_cus_BlockWrapper).classList.add(_.hide);
    this.querySelector(_$.wrp_per_Cart).classList.remove(_.hide);

    let variantJson = this.selectedVariant;
    
    let productInfo = this.getConfirmationBoxInfoHTML(false).replace('{{Title}}',this.personalizationJson.product.title).replace('{{Price}}',`$${Shopify.formatMoney(variantJson.price)}`);
    let locations = Object.keys(this.userCustomizations);
    let productTemplate = this.personalizationJson.productTemplate || '';
    let cPrice = 0;
    cPrice += variantJson.price;
    let locationHtml = [];
    let locationCount = 0;
    locations.forEach(element => {
      let currentLocation = this.userCustomizations[element];


      if(currentLocation.completed == false || currentLocation.completed == undefined){
        return;
      }
      locationCount++
      let tmp = [];
      if (this.isBundleProduct) {
        tmp.push(currentLocation.bundle_product);
      }
      tmp.push(currentLocation.name);
      tmp.push(currentLocation.type);
      let price = 0;
      switch (currentLocation.type) {
        case type.monogram:
          if(currentLocation.details.monogramText != ""){
            tmp.push(`"${currentLocation.details.monogramText}"`);
          }
          if(currentLocation.details.icon != ""){
            tmp.push(currentLocation.details.icon);
          }
          tmp.push(currentLocation.details.fonts);
          tmp.push(currentLocation.details.colors);
          price = this.personalizationJson.InitialsProduct.variants[0].price
          break;
        case type.name:
          if(currentLocation.details.nameText != ""){
            tmp.push(`"${currentLocation.details.nameText}"`);
          }
          if(currentLocation.details.icon != ""){
            tmp.push(currentLocation.details.icon);
          }
          tmp.push(currentLocation.details.fonts);
          tmp.push(currentLocation.details.colors);
          price = this.personalizationJson.InitialsProduct.variants[0].price
          break;
        case type.patch:
          tmp.push(`"${currentLocation.details.patches.name}"`);
          price = parseInt(currentLocation.details.patches.price);
          break;
      }
      price = productTemplate == 'personalization-button' ? 0 : price;
      cPrice += price;

      let infoText = tmp.join(' - ');
      let personalizeProductPrice = productTemplate == 'personalization-button' ? 'Free' : `$${Shopify.formatMoney(price)}`;
      locationHtml.push(this.getConfirmationBoxInfoHTML().replace('{{Title}}',infoText).replace('{{Price}}', personalizeProductPrice).replaceAll('{{locationId}}',element));
    });

    productInfo += locationHtml.join('');

    productInfo += this.getConfirmationBoxInfoHTML(false).replace('{{Title}}',"SUBTOTAL").replace('{{Price}}',`$${Shopify.formatMoney(cPrice)}`);

    this.querySelector(_$.wrp_cus_InfoWrapper).innerHTML = productInfo;

    let isDisabled = this.isAllLocationsCompleted;
    if(this.isBundleProduct){
      isDisabled = (this.BF_getRemainingLocations.length == 0);
    }
    this.querySelector(_$.btn_AddMore_confirmPer).classList.toggle(_.disabled,isDisabled);
    this.querySelector(_$.btn_AddMore_confirmPer).disabled = isDisabled;
    this.querySelector(_$.wrp_locationConfirmationBox).classList.add(_.hide);
    this.querySelector(_$.btn_per_AddToCart).disabled = (locationCount == 0);
    this.querySelector(_$.btn_per_AddToCart).classList.toggle(_.disabled,(locationCount == 0));
    this.querySelectorAll(`${_$.personalizationPreview}:not(.${_.previewLocked})`).forEach(element => { element.remove() });
    

    let firstLocation = this.userCustomizations[locations[0]];
    if(this.isBundleProduct){
      this.querySelector(`${_$.btn_bundle_product}[data-name="${firstLocation.bundle_product}"]`).click();
      this.querySelector(`${_$.btn_bundle_location}[data-name="${firstLocation.name}"]`).click();
    }else{
      this.querySelector(`${_$.btn_location}[data-position-name="${firstLocation.name}"]`).click();
    }
  }

  // Text Input
  _InputTextListener(input){
    input.addEventListener('input',() => {
      let inputType = input.dataset.type;
      let wrapper = input.closest(_$.wrp_accordion);
      let nextBtn = wrapper.querySelector(_$.btn_next);
      let fieldWrapper = input.closest('.field');
      let maxLength = input.max;

      if(inputType == type.monogram){
        input.value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '').substring(0, maxLength);
      }else{
        input.value = input.value.replace(/[^A-Za-z0-9 ]/g, '').substring(0, maxLength);
      }
      let textValue = input.value;
      let previewLocaton = this.querySelector(`${_$.personalizationPreview}[data-location-id="${this.currentLocation}"]`);
      // previewLocaton.insertAdjacentHTML('afterbegin',`<span>${textValue}</span>`);
      
      this.inputAndSymbolValidation();

      fieldWrapper.querySelector('.custom_name_max').querySelector(_$.text_count).innerHTML = textValue.length;
      this.updateUserSelection();
    });
  }

  _handleVariantChange(event){
    let element = event.detail.element;
    let personalizationButton = document.querySelector(_$.btn_personalization);
    let disablePersonalization = this.personalizationJson.variantMetaData[element.dataset.variantId].disablePersonalization;
    if(personalizationButton){
      personalizationButton.classList.toggle(_.hide,disablePersonalization);
      personalizationButton.classList.toggle(_.disabled,disablePersonalization);
      personalizationButton.disabled = disablePersonalization;
    }
  }

  _setFontSize() {
    // console.log(this.querySelectorAll(`${_$.personalizationPreview}:not([data-type="patch"])`))
    this.querySelectorAll(`${_$.personalizationPreview}:not([data-type="patch"])`).forEach(element => {
      let deskfont =  element.style.getPropertyValue('--decorations_font_size_desktop').replace('px','');
      let mobilefont =  element.style.getPropertyValue('----decorations_font_size_mobile').replace('px','');
      let fontSize = (element.closest(_$.wrp_per_Image).offsetWidth * (deskfont / 100)) + 'px';
      element.style.setProperty('--decorations_font_size', fontSize);
    });
  }


  /**
   * ---------------------------------------------------------------------------------------
   * -----------------------------BUNDLE PRODUCT FUNCTIONS----------------------------------
   * ---------------------------------------------------------------------------------------
   */

  /**
   * Get Functions
   */

  get BF_completedLocations(){
    let currentLocation = this.userCustomizations[this.currentLocation];
    let completedCount = 0
    let BundleProductLocations = Object.keys(this.personalizationJson.locations).filter(element => {
        return this.personalizationJson.locations[element].B_product_name == currentLocation.bundle_product;
    }).map(element => this.personalizationJson.locations[element].B_location_name);

    BundleProductLocations.forEach(locationName => {
      let location = Object.keys(this.userCustomizations).filter(key => {
        return (this.userCustomizations[key].name == locationName && this.userCustomizations[key].bundle_product == currentLocation.bundle_product);
      }).map(key => this.userCustomizations[key])[0]; 
      if(location){
        if(location.completed == true){
          completedCount++;
        }
      }
    });
    return completedCount;
  }

  get BF_getProductLocations(){
    let selectedProduct = this.querySelector(`${_$.btn_bundle_product}.${_.active}`).dataset.name;
    let locations = Object.keys(this.personalizationJson.locations).map(element => this.personalizationJson.locations[element]).filter(element => element.B_product_name == selectedProduct);
    return locations;
  }

  get BF_getActiveLocation(){
    let selectedProduct = this.querySelector(`${_$.btn_bundle_product}.${_.active}`).dataset.name;
    let selectedLocation = this.querySelector(`${_$.btn_bundle_location}.${_.active}`).dataset.name;
    return this.BF_getProductLocations.filter(element => (element.B_location_name == selectedLocation && element.B_product_name == selectedProduct))[0];
  }

  get BF_getSelectedProduct(){
    return this.querySelector(`${_$.btn_bundle_product}.${_.active}`).dataset.name;
  }

  get BF_getRemainingLocations(){
    let userLocations = this.userCustomizations;
    let productLocations = {...this.personalizationJson.locations};
    Object.keys(userLocations).forEach(location => {
      delete productLocations[location];
    });
    return {
      locations:productLocations,
      length: Object.keys(productLocations).length,
      array: Object.keys(productLocations).map(id => productLocations[id])
    };
  }

  BF_getProductImage(firstProduct = false){
    let selectedProduct = ""
    if(firstProduct == true){
      selectedProduct = this.querySelector(`${_$.btn_bundle_product}`).dataset.name;
    }else{
      selectedProduct = this.querySelector(`${_$.btn_bundle_product}.${_.active}`).dataset.name;
    }
    let image = Object.keys(this.selectedVariant.metadata.variant_location_images).map(element => this.selectedVariant.metadata.variant_location_images[element]).filter(element => element.B_bundle_product_name == selectedProduct)[0];
    return image;
  }


  /**
   * Global functions
   */

  BF_resetBundle(){
    this.querySelectorAll(_$.btn_bundle_product).forEach(button => {
      button.classList.remove(_.active,_.completed);
    });
    this.querySelectorAll(_$.btn_bundle_location).forEach(button => {
      button.classList.remove(_.active,_.completed,_.hide);
      button.classList.add(_.disabled);
      button.disabled = true;
    });
  }

  BF_setProductLocations(){
    let locations = this.BF_getProductLocations.map(element => element.location_name);
    this.personalizationJson.product_location_ordering[this.BF_getSelectedProduct].forEach((element,index) => {
      this.querySelector(`${_$.btn_bundle_location}[data-name="${element}"]`).style.order = (index + 1);
    });
    this.querySelectorAll(_$.btn_bundle_location).forEach(button => {
      button.classList.toggle(_.hide,!locations.includes(button.dataset.name));
      button.classList.toggle(_.disabled,!locations.includes(button.dataset.name));
      button.disabled = !locations.includes(button.dataset.name);
      if(locations.includes(button.dataset.name) == false) button.removeAttribute('style');
    });
  }

  BF_initializeProduct(){
    let selectedProduct = this.BF_getSelectedProduct;
    let productLocations = Object.keys(this.userCustomizations).map(element => this.userCustomizations[element]).filter(element => (element.bundle_product == selectedProduct && element.completed == true)).reverse();
    // console.log(">>> ",productLocations)
    productLocations.forEach(location => {
      let button = this.querySelector(`${_$.btn_bundle_location}[data-name="${location.name}"]`);
      button.classList.add(_.completed);
      button.click();
    });
  }

  BF_resetProduct(){
    this.querySelectorAll(_$.btn_bundle_location).forEach(button => {
      button.classList.remove(_.active,_.completed);
    });
    this.resetLocationCustomization();
  }

  BF_ShowProductLocationPreview(){
    this.querySelectorAll(`${_$.personalizationPreview}:not(.${_.previewLocked})`).forEach(element => element.remove());
    let selectedProduct = this.BF_getSelectedProduct;
    this.querySelectorAll(`${_$.personalizationPreview}`).forEach(element => {
      element.classList.toggle(_.hide,element.dataset.product != selectedProduct)
    });
  }

  BF_updateProductImage(){
    let productImage = this.BF_getProductImage();
    let imageElement = this.personalizationImageWrapper.querySelector('img');
    let currentImageId = imageElement.dataset.imageId;
    if(productImage.B_fileId != currentImageId){
      imageElement.outerHTML = productImage.B_product_file_html;
    }
  }


  /**
   * Action Listeners
   */

  // Bundle Product Button Listener

  _BundleProductButtonListener(button){
    button.addEventListener('click',() => {
      if(button.classList.contains(_.active)) return;
      this.currentLocation = null;
      this.querySelectorAll(_$.btn_bundle_product).forEach(button => {
        button.classList.remove(_.active);
        button.ariaSelected = false;
      });
      button.classList.add(_.active);
      button.ariaSelected = true;
      this.classList.remove(_.personalizationActivated);
      this.BF_setProductLocations();
      this.BF_resetProduct();
      this.BF_ShowProductLocationPreview();
      this.BF_updateProductImage();
      if(button.classList.contains(_.completed)){
        this.BF_initializeProduct();
      }
      this.querySelector(_$.wrp_locationConfirmationBox).classList.add(_.hide);
      let typeAccordionBtn = this.accordion_type.querySelector(_$.btn_accordionToggle);
      if(typeAccordionBtn.ariaExpanded == 'true') typeAccordionBtn.click();
      let detailsAccordionBtn = this.accordion_details.querySelector(_$.btn_accordionToggle);
      if(detailsAccordionBtn.ariaExpanded == 'true') detailsAccordionBtn.click();
    });
  }

  // Bundle Location Button Listener

  _BundleLocationButtonListener(button){
    button.addEventListener('click',() => {
      if(button.classList.contains(_.active)) return;
      this.querySelectorAll(_$.btn_bundle_location).forEach(button => {
        button.classList.remove(_.active);
        button.ariaSelected = false;
      });
      button.classList.add(_.active);
      button.ariaSelected = true;
      let oldLocation = this.currentLocation;
      this.currentLocation = this.BF_getActiveLocation.id;
      if(this.userCustomizations[oldLocation]){
        if(this.userCustomizations[oldLocation].completed == false){
          delete this.userCustomizations[oldLocation];
        }
      }
      this.classList.add(_.personalizationActivated);
      this.updateLocationImage();
      this.displayLocationTypes();
      this.setupTextLimitation();

      this.querySelector(_$.wrp_locationConfirmationBox).classList.add(_.hide);

      if(button.classList.contains(_.completed)){
        this.handlePersonalizationPreview(this.currentLocation);
        this.initializeSelectedLocation();
        let typeAccordionBtn = this.accordion_type.querySelector(_$.btn_accordionToggle);
        if(typeAccordionBtn.ariaExpanded == 'false') typeAccordionBtn.click();
        this.querySelector(_$.btn_confirmPersonalization).classList.remove(_.hide);
        return;
      }else{
        this.resetLocationCustomization();
        this.handlePersonalizationPreview(this.currentLocation);
      }

      this.updateUserSelection();
      let typeAccordionBtn = this.accordion_type.querySelector(_$.btn_accordionToggle);
      if(typeAccordionBtn.ariaExpanded == 'false') typeAccordionBtn.click();
    });
  }

}
customElements.define('product-personalization',productPersonalization);


// ...existing code...
window.openPersonalization = async function(trigger) {
  try {
    // resolve the button element (accepts element, event, or undefined)
    let btn = null;
    if (trigger instanceof Event) btn = trigger.currentTarget || trigger.target;
    else btn = trigger;
    if (!(btn && btn.nodeType === 1 && btn.dataset && btn.dataset.productUrl)) {
      // fallback: find any personalization button with data-product-url
      btn = document.querySelector(`${_$.btn_personalization}[data-product-url]`);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: `pdp_personalize_button`
    });

    const productUrl = btn?.dataset?.productUrl;
    const existing = btn.closest('.quick-view__container') ? btn.closest('.quick-view__container').querySelector('product-personalization') : document.querySelector('product-personalization');
    if (!productUrl || existing) {
      if (existing) { existing.open(); }
      return;
    }

    // Avoid duplicate injection if same product already appended
    if (existing && existing.dataset && existing.dataset.sourceUrl === productUrl) {
      existing.open();
      return;
    }

    const container = document.querySelector('.shopify-section--single-product');
    if (!container) {
      console.warn('openPersonalization: .shopify-section--single-product not found');
      if (existing) existing.open();
      return;
    }

    // show loading animation overlay (create if missing)
    let overlay = document.querySelector('.personalization-overlay');
    let createdOverlay = false;
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'personalization-overlay';
      // simple spinner markup (styling assumed in CSS). Adjust if you have your own spinner markup.
      overlay.innerHTML = '<div class="personalization-spinner" aria-hidden="true"></div>';
      document.body.appendChild(overlay);
      createdOverlay = true;
    }
    overlay.classList.add('loading-animation');
    document.body.setAttribute('aria-busy', 'true');

    // fetch product-personalization view HTML
    const viewUrl = productUrl + (productUrl.includes('?') ? '&' : '?') + 'section_id=product-personalization';
    const res = await fetch(viewUrl, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Failed to fetch personalization view (${res.status})`);
    const html = await res.text();

    // extract <product-personalization> element if present
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const perEl = doc.querySelector('product-personalization');
    const markup = perEl ? perEl.outerHTML : html;

    // insert before end of the product section
    container.insertAdjacentHTML('beforeend', markup);

    // mark inserted element with source URL to avoid duplicates later
    const appended = container.querySelector('product-personalization:last-of-type');
    if (appended) appended.dataset.sourceUrl = productUrl;

    // ensure custom element upgraded, then open
    try {
      await customElements.whenDefined('product-personalization');
    } catch (e) {
      /* ignore */
    }

    // hide loading animation
    overlay.classList.remove('loading-animation');
    document.body.removeAttribute('aria-busy');

    if (appended && typeof appended.open === 'function') {
      appended.open();
    } else if (existing && typeof existing.open === 'function') {
      existing.open();
    }
    window.accordionListeners();
  } catch (err) {
    console.error('openPersonalization error:', err);
    const overlay = document.querySelector('.personalization-overlay');
    if (overlay) overlay.classList.remove('loading-animation');
    document.body.removeAttribute('aria-busy');
    const existing = document.querySelector('product-personalization');
    if (existing && typeof existing.open === 'function') existing.open();
  }
};
// ...existing code...

if (window.location.search.includes("?openPersonalization=true")) {
  if(document.querySelector('.personalization-overlay')) document.querySelector('.personalization-overlay').classList.add("loading-animation");
  window.openPersonalization();
}

window.addEventListener("variantChangedQuickView",(event) => {
  if(!event.detail) return;
  personalizationBtnUpdate(event.detail.element.closest('.quick-view__container'),event.detail.element);
});

window.addEventListener("variantChanged",(event) => {
  if(!event.detail) return;
  personalizationBtnUpdate(event.detail.element.closest('.shopify-section--single-product'),event.detail.element);
});

function personalizationBtnUpdate(container,swatch) {
  const _personalizationVariantMetaEl = container.querySelector('#personalization-variant-metafield-data');
  let _personalizationVariantMeta = {};
  if (_personalizationVariantMetaEl) {
    try {
      _personalizationVariantMeta = JSON.parse((_personalizationVariantMetaEl.textContent || _personalizationVariantMetaEl.innerText || '{}').trim());
    } catch (err) {
      console.error('Failed to parse personalization variant metafield JSON', err);
      _personalizationVariantMeta = {};
    }
  }

  const personalizationButton = container.querySelector(_$.btn_personalization);

  // variant id may be stored on the swatch
  const variantId = swatch.dataset.variantId || swatch.getAttribute('data-variant-id') || swatch.dataset.variant || swatch.value;

  let disablePersonalization = false;

  if (variantId && _personalizationVariantMeta) {
    const meta = _personalizationVariantMeta[variantId] || _personalizationVariantMeta[String(variantId)];
    if (meta) {
      // support both snake_case and camelCase keys
      if (typeof meta.disable_personalization !== 'undefined') {
        disablePersonalization = Boolean(meta.disable_personalization);
      } else if (typeof meta.disablePersonalization !== 'undefined') {
        disablePersonalization = Boolean(meta.disablePersonalization);
      } else if (typeof meta.disablePersonalization === 'undefined' && typeof meta.disable_personalization === 'undefined') {
        // fallback to older metadata shape used elsewhere
        disablePersonalization = Boolean(meta.disablePersonalization || meta.disable_personalization || false);
      }
    }
  }

  if (personalizationButton) {
    personalizationButton.classList.toggle(_.hide, disablePersonalization);
    personalizationButton.classList.toggle(_.disabled, disablePersonalization);
    personalizationButton.disabled = disablePersonalization;
  }
}

/**
 * Edit Personalization
 */

class personalizationEditButton extends HTMLElement{
  connectedCallback() {
    let personalization = document.querySelector('product-personalization');
    this.addEventListener('click',() =>{
      // personalization.userCustomizations[this.dataset.location].completed = false;
      personalization.querySelector(_$.wrp_per_Cart).classList.add(_.hide);
      personalization.querySelector(_$.wrp_cus_BlockWrapper).classList.remove(_.hide);
      if(personalization.isBundleProduct){
        let location = personalization.personalizationJson.locations[this.dataset.location];
        personalization.querySelector(`${_$.btn_bundle_product}[data-name="${location.B_product_name}"]`).classList.remove(_.active);
        personalization.querySelector(`${_$.btn_bundle_product}[data-name="${location.B_product_name}"]`).click();
        setTimeout(() => {
          personalization.querySelector(`${_$.btn_bundle_location}[data-name="${location.B_location_name}"]`).classList.remove(_.active);
          personalization.querySelector(`${_$.btn_bundle_location}[data-name="${location.B_location_name}"]`).click();
        }, 100);
      }else{
        personalization.querySelector(`${_$.btn_location}[data-location-id="${this.dataset.location}"]`).classList.remove(_.active);
        personalization.querySelector(`${_$.btn_location}[data-location-id="${this.dataset.location}"]`).click();
      }
      let typeAccordionBtn = personalization.accordion_type.querySelector(_$.btn_accordionToggle);
      if(typeAccordionBtn.ariaExpanded == 'false') typeAccordionBtn.click();
      personalization.querySelector(_$.wrp_locationConfirmationBox).classList.add(_.hide);
      personalization.querySelector(_$.btn_confirmPersonalization).classList.remove(_.hide);
      personalization.classList.remove(_.confirmationScreenActive);
    });
  }
}
customElements.define('personalization-edit-button',personalizationEditButton);

/**
 * Delete Personalization
 */
class personalizationDeleteButton extends HTMLElement{
  connectedCallback() {
    let personalization = document.querySelector('product-personalization');
    this.addEventListener('click',() =>{
      personalization.currentLocation = this.dataset.location;
      personalization.userCustomizations[this.dataset.location].completed = false;
      delete personalization.userCustomizations[this.dataset.location].type;
      if(personalization.isBundleProduct){
        let location = personalization.personalizationJson.locations[this.dataset.location];
        let locationsName = Object.keys(location).map(ele => location[ele].bundle_product);
        // console.log(location,`${_$.btn_bundle_product}[data-name="${location.B_location_name}"]`);
        // console.log(personalization.querySelector(`${_$.btn_bundle_product}[data-name="${location.B_location_name}"]`))
        personalization.querySelector(`${_$.btn_bundle_product}[data-name="${location.B_product_name}"]`).classList.toggle(_.completed,!(personalization.BF_completedLocations == 0));
        personalization.querySelector(`${_$.btn_bundle_location}[data-name="${location.B_location_name}"]`).classList.remove(_.completed);
      }else{
        personalization.querySelector(`${_$.btn_location}[data-location-id="${this.dataset.location}"]`).classList.toggle(_.completed,false);
      }
      personalization.querySelector(`${_$.personalizationPreview}[data-location-id="${this.dataset.location}"]`).remove();
      personalization.updateUserSelection();
      personalization.resetLocationCustomization();
      personalization._cusConfirmation();
    });
  }
}
customElements.define('personalization-delete-button',personalizationDeleteButton);


/**
 * Cart Remove
 */
class cartPersonalizationRemove extends HTMLElement{
  connectedCallback() {
    let cartItemWrapper = this.closest(_$.wrp_cart_item);
    let perItemsJson = JSON.parse(cartItemWrapper.querySelector('script[type="application/json"].personalization-items-json').innerHTML);
    let updates = {};
    updates[cartItemWrapper.dataset.key] = 0;
    Object.keys(perItemsJson).forEach(key => {
      updates[key] = 0;
    });
    this.addEventListener('click',() =>{
      cartItemWrapper.classList.add('cart__item--removing');
      calpak.updateCartItems(updates,(data) => {
        calpak.updateCart(data);
        // console.log("Items Deleted");
        window.dispatchEvent(new CustomEvent('refreshAjaxSideCart'));
      });
    });
  }
}
customElements.define('cart-personalization-remove',cartPersonalizationRemove);


/**
 * Cart QTY update
 */
class personalizeQtyBox extends HTMLElement{
  connectedCallback(){
    this.cartItemWrapper = this.closest(_$.wrp_cart_item);
    this.perItemsJson = JSON.parse(this.cartItemWrapper.querySelector('script[type="application/json"]').innerHTML);
    this.input = this.querySelector('input[name="qty"]');
    this.querySelectorAll(_$.btn_cart_qty).forEach(button => this._cartQtyButtonListener(button))
  }
  _cartQtyButtonListener(button){
    button.addEventListener('click',() => {
      let inputValue = parseInt(this.input.value);
      // button.classList.contains('per-qty-button--less') ? inputValue-- : inputValue++; 
      if (button.classList.contains('per-qty-button--less')) {
        if (inputValue > 1) {
          inputValue--;
          this.cartItemWrapper.classList.add('cart__item--removing');
        } else {
          inputValue = 0;
          this.cartItemWrapper.classList.add('cart__item--removing');
        }
      } else {
        inputValue++;
        this.cartItemWrapper.classList.add('cart__item--removing');
      } 
      this.input.setAttribute('value',inputValue);
      this.input.value = inputValue;
      this.UpdateItemQty();
    });
  }
  UpdateItemQty(){
    let inputValue = parseInt(this.input.value);
    if(inputValue == 0) this.cartItemWrapper.classList.add('cart__item--removing');
    let updates = {};
    updates[this.cartItemWrapper.dataset.key] = inputValue;
    Object.keys(this.perItemsJson).forEach(key => {
      updates[key] = parseInt(this.perItemsJson[key].mainQty) * inputValue;
    });
    calpak.updateCartItems(updates,(data) => {
      calpak.updateCart(data);
      // console.log("Items Deleted");
      window.dispatchEvent(new CustomEvent('refreshAjaxSideCart'));
    });
  }
}
customElements.define('personalize-qty-box',personalizeQtyBox);

/**
 * Cart Personalization Button
 */
class cartPersonalizationButton extends HTMLElement{
  connectedCallback(){
    let button = this.querySelector('a');
    button.addEventListener('click',(event) => {
      event.preventDefault();
      let hrefLink = button.href;
      window.sessionStorage.setItem(sessionItem.cartPersonalizeItem,`${this.dataset.key}|${this.dataset.qty}`);
      window.location.href = hrefLink;
    });
  }
}
customElements.define('cart-personalization-btn',cartPersonalizationButton);

/**
 * Cart Edit Personalization
 */
class cartPersonalizationEditButton extends HTMLElement{
  connectedCallback(){
    let button = this.querySelector('a');
    let cartItemWrapper = this.closest(_$.wrp_cart_item) || this.closest('li');
    let perItemsJsonEdit = JSON.parse(cartItemWrapper.querySelector('script[type="application/json"].edit-personalization-json').innerHTML);
    let perItemsJson = JSON.parse(cartItemWrapper.querySelector('script[type="application/json"].personalization-items-json').innerHTML);
    button.addEventListener('click',(event) => {
      event.preventDefault();
      let hrefLink = button.href;
      let sessionJson = {
        perItemsJson,
        perItemsJsonEdit
      }
      window.sessionStorage.setItem(sessionItem.cartPersonalizeItemEdit,JSON.stringify(sessionJson));
      window.location.href = hrefLink;
    });
  }
}
customElements.define('cart-personalization-edit-btn',cartPersonalizationEditButton);




/*class toggleDropdown extends HTMLElement{
  connectedCallback() {
    this.button = this.querySelector('.js-toggle-button');
    this.list = this.querySelector('.js-toggle-list');
    this.button.addEventListener('click',this.handleToggle.bind(this));
    this.querySelectorAll('[role="option"]').forEach(element => {
      element.addEventListener('click',() => {
        this.querySelector('[role="option"][aria-selected="true"]').ariaSelected = false;
        element.ariaSelected = true;
        this.button.innerHTML = element.getAttribute('data-position-name');
        this.handleToggle();
        document.querySelector('product-personalization').dispatchEvent(
           new CustomEvent("personalization:change", {
            detail: { position: element.getAttribute('value') },
          }),
        );
      });
    });
  }
  handleToggle(){
    let isOpen = (this.button.ariaExpanded == 'true');
    this.button.ariaExpanded = isOpen ? false : true;
    this.list.classList.toggle('hidden',isOpen);
  }
}
customElements.define('toggle-dropdown',toggleDropdown);*/